import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { LoteAgendamento } from "../../../../services/LoteAgendamento";
import { IValidarPlanilhaProps } from "../../../../types/loteAgendamento";

export const useValidarPlanilhaLote = () => {
  return useMutation({
    mutationFn: (data: IValidarPlanilhaProps) =>
      LoteAgendamento.validarPlanilha(data),
    onError: ({
      response: {
        data: { mensagem },
      },
    }: any) => {
      toast.error(mensagem);
    },
  });
};
